import jquery from 'jquery';
import EventBus from '@/event-bus';
import Products from '@/products';
import Cart from '@/cart';
import FavoritesProducts from '@/favorites';
import Compare from '@/compare';
import UIMenu from '@/ui/ui_menu';
import UIAjaxFilter from '@/ui/ui_ajax-filter';
import UIAjaxProduct from '@/ui/ui_ajax-products/product';
import UIAjaxReviews from '@/ui/ui_ajax-reviews/reviews';
import { default as _Singleton } from '@/tools/singleton';

import UICartSelectors from '@/ui/ui_cart/default-selectors.json';
import UIFavoritesSelectors from '@/ui/ui_favorites/default-selectors.json';
import UICompareSelectors from '@/ui/ui_compare/default-selectors.json';
import UIMenuSelectors from '@/ui/ui_menu/default-selectors.json';
import UIAjaxFilterSelectors from '@/ui/ui_ajax-filter/default-selectors.json';
import UIAjaxProductSelectors from '@/ui/ui_ajax-products/product/default-selectors.json';
import UIAjaxReviewsSelectors from '@/ui/ui_ajax-reviews/reviews/default-selectors.json';

/**
 * @class
 * @private
 *
 * @description
 * DOM + widgetDOM
 */
var widgetDOM = function() {
  const UICartOptions = UICartSelectors;
  const UIFavoritesOptions = UIFavoritesSelectors;
  const UICompareOptions = UICompareSelectors;
  const UIMenuOptions = UIMenuSelectors;
  const UIAjaxFilterOptions = UIAjaxFilterSelectors;
  const UIAjaxProductOptions = UIAjaxProductSelectors;
  const UIAjaxReviewsOptions = UIAjaxReviewsSelectors;

  var UIComponentOptions = [
    {
      name: 'cart',
      options: UICartOptions
    },
    {
      name: 'favorites',
      options: UIFavoritesOptions
    },
    {
      name: 'compare',
      options: UICompareOptions
    },
    {
      name: 'menu',
      options: UIMenuOptions
    },
    {
      name: 'ajax-filter',
      options: UIAjaxFilterOptions
    },
    {
      name: 'ajax-product',
      options: UIAjaxProductOptions
    },
    {
      name: 'ajax-reviews',
      options: UIAjaxReviewsOptions
    }
  ];

  EventBus.subscribe('update_widget:insales:widgets', function({ widgetId, withoutUpdate }) {
    const widgetNode = jquery(`[data-widget-id="${widgetId}"]`);
    if (!widgetNode) {
      return;
    }

    // Обновление товаров
    const dataProducts = widgetNode.find('[data-product-id]');
    if (dataProducts.length > 0) {
      dataProducts.each((index, el) => {
        Products.initInstance(jquery(el));
      });
    }

    if (withoutUpdate) { return; }

    UIComponentOptions.forEach(function(uiComponentItem) {
      for (const option in uiComponentItem.options) {
        if (widgetNode.find(uiComponentItem.options[option].attr).length > 0) {
          switch (uiComponentItem.name) {
            case 'cart':
              Cart.forceUpdate();
              break;
            case 'favorites':
              FavoritesProducts.update();
              break;
            case 'compare':
              Compare.update();
              break;
            case 'menu':
              UIMenu.update();
              break;
            case 'ajax-filter':
              UIAjaxFilter.update();
              break;
            case 'ajax-product':
              UIAjaxProduct.update();
              break;
            case 'ajax-reviews':
              UIAjaxReviews.update();
              break;
            default:
          }
          break;
        }
      }
    });
  });
};

export default _Singleton(widgetDOM).getInstance();
